import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { orderBy } from 'lodash';
import { closeNetworkPanel } from '../../store/membership/actions';
import {
  getAssociatedClubs,
  getAssociatedLeagueWebsites,
  getBadgeTotals,
  getCompetitionsAdministered,
  getLoggedInUser,
  isNetworkPanelOpen,
} from '../../store/membership/selectors';
import NetworkPanel from '../network-panel';
import { pitcheroDomain } from '../../lib/env';
import clubUrl from '../../lib/routing/club-url';

const NetworkPanelWrapper = ({
  badgeTotals,
  closePanel,
  clubs,
  currentClub,
  competitions,
  isOpen,
  leagueWebsites,
  user,
}) => {
  if (!user) {
    return null;
  }

  return (
    <NetworkPanel
      badgeTotals={badgeTotals}
      clubs={orderBy(clubs, ['isPrimaryClub', 'name'], ['desc', 'asc'])}
      competitions={orderBy(competitions, ['name'], ['asc'])}
      isOpen={isOpen}
      leagueWebsites={orderBy(leagueWebsites, ['name'], ['asc'])}
      logoutUrl={`https://${pitcheroDomain()}/logout?redirect=${clubUrl(currentClub, 'homepage')}`}
      onClose={closePanel}
      settingsUrl={`https://${pitcheroDomain()}/account/settings/details`}
      user={user}
    />
  );
};

NetworkPanelWrapper.defaultProps = {
  user: null,
};

NetworkPanelWrapper.propTypes = {
  badgeTotals: PropTypes.shape().isRequired,
  closePanel: PropTypes.func.isRequired,
  clubs: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  currentClub: PropTypes.shape({
    folder: PropTypes.string,
  }).isRequired,
  competitions: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  isOpen: PropTypes.bool.isRequired,
  leagueWebsites: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  user: PropTypes.shape(),
};

const mapStateToProps = (state) => ({
  badgeTotals: getBadgeTotals(state),
  clubs: getAssociatedClubs(state),
  competitions: getCompetitionsAdministered(state),
  isOpen: isNetworkPanelOpen(state),
  leagueWebsites: getAssociatedLeagueWebsites(state),
  user: getLoggedInUser(state),
});

export default connect(mapStateToProps, { closePanel: closeNetworkPanel })(NetworkPanelWrapper);
